import React from 'react';
import { createTheme } from '@mui/material/styles';

const myTheme = createTheme({
    palette: {
        primary: {
            main: '#3f51b5',
        },
        secondary: {
            main: '#f50057',
        },
    },
});

export { myTheme };